import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sisMapActions from "store/modules/rds_sisMap";
import $ from "jquery";
import { LoadingContext } from "../../loadingContext";

import "./sanitary.scss";

import { IoIosArrowForward } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { BsPlus, BsDash } from "react-icons/bs";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { WiDust } from "react-icons/wi";

import SisSelect from "store/sis/component/SisSelect";
import SisOverlay from "store/sis/SisOverlay";

class Sanitary extends Component {
	static contextType = LoadingContext; // ✅ contextType 사용
	state = {
		title: "보건",
		activeItem: "",
		lstEmd: [],
		lstYmd: [],
		lstGb: [],
		tourList: [],
		source:"",
		selectedGb: "0", // ✅ 추가: 선택된 구분 값을 저장할 변수 (기본값 "0")
	};

	// ✅ 추가: 구분(병원종류 등) 변경 시 state 업데이트
	handleGbChange = (value) => {
		this.setState({ selectedGb: value });
	};

	openSearchWrap = (evt) => {
		$("#livingWrap .itemsWrap").hide();
		$("#livingWrap .searchWrap").show();
		$("#livingWrap .close").show();
		$(".source").show();
		$("#livingWrap .searchWrap").css("top","60px");		

		const id = $(evt.target).closest(".item").attr("id");
		const title = $(evt.target).closest(".item").find("span").text();
		let source = "";

		
		if(id==="hospital"){
			this.getYmd("medical_info");		
			this.getGb(id);
			source = "감영병관리과";
		}else if(id==="hospital_night"){
			this.getYmd("medical_night_info");		
			this.getGb(id);
			source = "공공보건의료과";
		}
		this.setState({
			activeItem: id,
			title,
			source,
		});
	};

	closeSearchWrap = () => {
		$("#livingWrap .searchWrap").hide();
		$("#livingWrap .itemsWrap").show();
		$("#apartModal .close").click();
		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$("#livingWrap .close").hide();
		$(".source").hide();
		$("#livingWrap .searchWrap").css("top","");

		//this.selectwelfareSgg.refresh();
		//this.selectwelfareEmd.refresh();

		this.setState({
			activeItem: "",
			title: "보건",
		});		
	};

	// 읍면동 불러오기
	getEmd = (value) => {
		let lstEmd = [];

		$.ajax({
			url: "/map/getEmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				lstEmd = res;

				this.setState({
					lstEmd: [{ emdCd: "0", emdNm: "=== 전체 ===" }, ...lstEmd],
				});
			},
		});
	};

	getYmd = (value) => {
		let lstYmd = [];
		

		$.ajax({
			url: "/map/getYmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				
				lstYmd = res;

				this.setState({
					//lstYmd: [{ stdYmd: res[0].stdYmd, stdName: res[0].stdName }, ...lstYmd],
					//lstYmd: [{ stdYmd: "0", stdName: "=== 전체 ===" }, ...lstYmd],
					lstYmd: [...lstYmd],
				});
			},
		});
	};

	getGb = (id) => {
		let lstGb = [];
		

		 if(id==="hospital"){			
			lstGb = [
				{facilitiesGb:'종합병원',facilitiesNm:'종합병원'}, 
				{facilitiesGb:'요양병원',facilitiesNm:'요양병원'}, 
				{facilitiesGb:'치과병원',facilitiesNm:'치과병원'}, 
				{facilitiesGb:'정신병원',facilitiesNm:'정신병원'}, 
				{facilitiesGb:'한방병원',facilitiesNm:'한방병원'}, 
				{facilitiesGb:'의원',facilitiesNm:'의원'}, 
				{facilitiesGb:'치과의원',facilitiesNm:'치과의원'},
				{facilitiesGb:'한의원',facilitiesNm:'한의원'}, 
				{facilitiesGb:'부속의원',facilitiesNm:'부속의원'}
			];
		}else if(id==="hospital_night"){			
			lstGb = [
				{facilitiesGb:'공공심야어린이병원',facilitiesNm:'공공심야어린이병원'},
				{facilitiesGb:'협력약국',facilitiesNm:'협력약국'},
				{facilitiesGb:'공공심야약국',facilitiesNm:'공공심야약국'}
			];
		}else{
			this.setState({
				lstGb: [{ facilitiesGb: "0", facilitiesNm: "=== 전체 ===" }, ...lstGb],
			});	
		}
		this.setState({
				lstGb: [{ facilitiesGb: "0", facilitiesNm: "=== 전체 ===" }, ...lstGb],
		});	
	};

	

	// 오버레이 클릭 이벤트(모달창 띄움)
	_overlayClickEvent = (ele, id, activeItem, noProps = false ,mapZoom = false) => {
		const { actions, layout, sis } = this.props;

		let overlayElement;
		let crsCode = "EPSG:4326";
		let offset;

		 if (activeItem === "hospital") {
			let parkGb = ele.gubun;
			crsCode = "EPSG:5186";
			let name = "";
			let classNm = "";

			switch (parkGb) {
				case "종합병원":
					name = "종합";
					classNm = "tag hospital";
					break;
				case "요양병원":
					name = "요양";
					classNm = "tag hospital2";
					break;
				case "치과병원":
					name = "치과";
					classNm = "tag hospital3";
					break;
				case "정신병원":
					name = "정신";
					classNm = "tag hospital4";
					break;
				case "한방병원":
					name = "한방";
					classNm = "tag hospital5";
					break;
				case "의원":
					name = "의원";
					classNm = "tag hospital6";
					break;
				case "치과의원":
					name = "치과의원";
					classNm = "tag hospital7";
					break;
				case "한의원":
					name = "한의원";
					classNm = "tag hospital8";
					break;
				case "부속의원":
					name = "부속";
					classNm = "tag hospital9";
					break;
			}
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="livingTitle">{ele.hospitalNm}</span>
					<span className={classNm}>{name}</span>
					<span className="livingAddress">
						{ele.addr}
					</span>

					<table>
						<caption>병원정보</caption>
						<tbody>
							<tr>
								<th>병원종류</th>
								<td>{ele.gubun ? ele.gubun : "-"}</td>
							</tr>
							<tr>
								<th>전화번호</th>
								<td>{ele.tel ? ele.tel : "-"}</td>
							</tr>							
						</tbody>
					</table>
					{/*<span>병원종류 : {ele.gubun}</span>
					<span>전화번호 : {ele.tel}</span>*/}
				</>
			);
		} else if (activeItem === "hospital_night") {
			let parkGb = ele.gubun;
			crsCode = "EPSG:5186";
			let name = "";
			let classNm = "";

			switch (parkGb) {
				case "공공심야어린이병원":
					name = "어린이";
					classNm = "tag hospital";
					break;
				case "협력약국":
					name = "협력약국";
					classNm = "tag hospital2";
					break;
				case "공공심야약국":
					name = "공공심야약국";
					classNm = "tag hospital3";
					break;
			}
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="livingTitle">{ele.hospitalNm}</span>
					<span className={classNm}>{name}</span>
					<span className="livingAddress">
						{ele.addr}
					</span>

					<table>
						<caption>의료시설</caption>
						<tbody>
							<tr>
								<th>시설종류</th>
								<td>{ele.gubun ? ele.gubun : "-"}</td>
							</tr>
							<tr>
								<th>진료시간</th>
								<td>
									{ele.surgeryHours ? ele.surgeryHours.split(',').map((line, index) => (
										<React.Fragment key={index}>
											{line.trim()}
											{index !== ele.surgeryHours.split(',').length - 1 && <br />}
										</React.Fragment>
									)) : "-"}
								</td>
							</tr>	
							<tr>
								<th>전화번호</th>
								<td>{ele.tel ? ele.tel : "-"}</td>
							</tr>							
						</tbody>
					</table>
					{/*<span>병원종류 : {ele.gubun}</span>
					<span>전화번호 : {ele.tel}</span>*/}
				</>
			);
		}  

		actions.addResultOverlay({
			element: overlayElement,
			data: ele,
			id,
			crsCode,
			className: "removeOverlayWrap",
			isTop: true,
			noProps,
			offsetValue: offset,
			mapZoom,
		});
	};

	// 오버레이 클릭 이벤트(겹치는거 확인)
	overlayClickEvent = (ele, evt, overlay) => {
		const { actions, layout, sis } = this.props;

		let col = "";
		const activeItem = $(evt.target).closest(".sisOverlayWrap").find("span:first").attr("class");

		if (activeItem === "hospital") col = "hospitalNm";
		else if (activeItem === "hospital_night") col = "hospitalNm";

		let id = `living_${activeItem ? activeItem : "dust"}_removeOverlay`;
		$(`#${id}`).remove();

		let existOverlay = sis.sisMap.map.getOverlayById(id);
		if (existOverlay) sis.sisMap.map.removeOverlay(existOverlay);

		const arrOverlays = [];
		const pos = overlay.getPosition();
		const interval = 1;
		let xInterval = 0;
		let yInterval = 0;
		const overlays = sis.sisMap.map.getOverlays().getArray();

		$.each(overlays, (idx, item) => {
			let targetPos = item.getPosition();

			if (targetPos) {
				targetPos = targetPos;

				xInterval = Math.abs(pos[0] - targetPos[0]);
				yInterval = Math.abs(pos[1] - targetPos[1]);

				if (xInterval <= interval && yInterval <= interval) {
					//if (activeItem !== "park") {
					//	const id = item.getId();

					//	if (id.indexOf("dust") > -1) arrOverlays.push(item);
					//} else {
						arrOverlays.push(item);
					//}
				}
			}
		});
		if(activeItem === "weather"|| activeItem.trim() === ""){
			arrOverlays.length = 0; // 배열 초기화
		}
		if (arrOverlays.length > 1) {
			
			   // 오버레이 생성
			   const overlayElement = document.createElement("div");
			   document.body.appendChild(overlayElement);
			   overlayElement.className = "overlaySelector";
			   overlayElement.id = "overlaySelector";
   
			   let overlay = sis.sisMap.map.getOverlayById("overlaySelector");
   
			   if (overlay) sis.sisMap.map.removeOverlay(overlay);
			   overlay = new SisOverlay(`#overlaySelector`, sis.sisMap.map, "bottom-center", [0, 0]);
			   overlay.setPosition(pos);
			   $(overlayElement).parent().css("z-index", 9999);
   
			   arrOverlays.forEach((item) => {
				  const props = item.getProperties();
   
				  if (props[col]) {
					 const element = document.createElement("div");
					 element.innerText = props[col];
					 $(overlayElement).append(element);
   
					 $(element).on("click", () => {
						this._overlayClickEvent(props, id, activeItem, true);
						sis.sisMap.map.removeOverlay(overlay);
					 });
				  }
   
				  // $(overlayElement).append(`<div>${props.buildNm}</div>`);
			   });
			//}
		 } else {
			this._overlayClickEvent(ele, id, activeItem);
		 }

		return;
	};

	// 오버레이 생성
	createOverlay = (data, id) => {
		const { actions } = this.props;
		const { activeItem } = this.state;

		const sggCode = $("select#selectLivingSgg").val();
		const sggName = $("select#selectLivingSgg option:selected").text();


		let weatherData = [];

		if(activeItem==="weather"){
			const params = {
				sggName: sggCode === "0" ? "" : sggName,
			};
			$.ajax({
				url: "/map/getWeatherList",
				type: "post",
				data: params,
				async: false,
				success: (res) => {
					weatherData = res;
				},
			});
		}else if (activeItem != "dust" && activeItem != "tour"  ) {
			$(".tabWrap .tab.active .searchWrap .listWrap").remove();
			$(".tabWrap .tab.active .searchWrap").append("<div class='listWrap'><span class='cnt'>검색결과 <a>" + data.length.toLocaleString() + "</a>건</span></div>");
		}



		data.forEach((ele, idx) => {
			let overlayElement;

			 if (activeItem === "hospital") {
				let parkGb = ele.gubun;				
				let name = "";
				let classNm = "";

				switch (parkGb) {
				case "종합병원":
					name = "종합";
					classNm = "tag hospital";
					break;
				case "요양병원":
					name = "요양";
					classNm = "tag hospital2";
					break;
				case "치과병원":
					name = "치과";
					classNm = "tag hospital3";
					break;
				case "정신병원":
					name = "정신";
					classNm = "tag hospital4";
					break;
				case "한방병원":
					name = "한방";
					classNm = "tag hospital5";
					break;
				case "의원":
					name = "의원";
					classNm = "tag hospital6";
					break;
				case "치과의원":
					name = "치과의원";
					classNm = "tag hospital7";
					break;
				case "한의원":
					name = "한의원";
					classNm = "tag hospital8";
					break;
				case "부속의원":
					name = "부속";
					classNm = "tag hospital9";
					break;
				}
				overlayElement = (
					<>
						<span className={activeItem}>
							<span className={classNm} style={{marginRight:"3px"}}>{name}</span>
							{ele.hospitalNm}
							</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.hospitalNm}</span>`);
			}else if (activeItem === "hospital_night") {
				let parkGb = ele.gubun;				
				let name = "";
				let classNm = "";

				switch (parkGb) {
					case "공공심야어린이병원":
						name = "어린이";
						classNm = "tag hospital";
						break;
					case "협력약국":
						name = "협력약국";
						classNm = "tag hospital2";
						break;
					case "공공심야약국":
						name = "공공심야약국";
						classNm = "tag hospital3";
						break;
				}
				overlayElement = (
					<>
						<span className={activeItem}>
							<span className={classNm} style={{marginRight:"3px"}}>{name}</span>
							{ele.hospitalNm}
						</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.hospitalNm}</span>`);
			}

			let overlayConfig = {
				element: overlayElement,
				data: ele,
				
			};
			
			// "weather"일 경우 actions.addResultOverlay() 호출하지 않음
			if (activeItem !== "weather") {
				if (["hospital", "hospital_night"].includes(activeItem)) {
					Object.assign(overlayConfig, {
						className: "livingOverlayWrap",
						crsCode: "EPSG:5186",
						id: `${id}_${ele.gid}`,
						onClick: this.overlayClickEvent,
						minZoom: 6,
						maxZoom: 10,
					});
				} else if (activeItem === "tour") {
					Object.assign(overlayConfig, {
						className: "tourOverlayWrap",
						id: `${id}_${ele.spotAreaId}`
					});
					
				}
			
				actions.addResultOverlay(overlayConfig);
			}
			
		});

		data.forEach((ele, idx) => {
			let overlayElement;
			 if (activeItem==="hospital"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						   data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						   data-id='${id}' 
						   data-active-item='${activeItem}'>
					  ${ele.hospitalNm}
					</span>`
				  );
			}else if (activeItem==="hospital_night"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						   data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						   data-id='${id}' 
						   data-active-item='${activeItem}'>
					  ${ele.hospitalNm}
					</span>`
				  );
			}	
			
		});

		$(".tabWrap .tab.active .searchWrap .listWrap").on("click", "span", (event) => {
			const target = $(event.currentTarget);
		
			const eleAttr = target.attr("data-ele");
			const id = target.attr("data-id")+"_removeOverlay";
			const activeItem = target.attr("data-active-item");
		
			if (!eleAttr) {
				console.error("data-ele 값이 없습니다.");
				return;
			}
		
			try {
				// ✅ JSON.parse() 한 번만 실행
				const ele = JSON.parse(eleAttr);
				
				// ✅ `this._overlayClickEvent()`를 호출하도록 변경 (화살표 함수 덕분에 this 유지됨)
				if (typeof this._overlayClickEvent === "function") {
					const mapZoom = true;
					const noProps = false;
					this._overlayClickEvent(ele, id, activeItem,noProps,mapZoom);
				} else {
					console.error("_overlayClickEvent 함수가 존재하지 않습니다.");
				}
			} catch (error) {
				console.error("JSON 파싱 오류:", error);
			}
		});

		if(activeItem === "park" || activeItem === "hospital" || activeItem === "hospital_night"){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","270px");
		}else if(activeItem === "wifi"){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","230px");
		}
	};

	// 트리 범례 생성
	createTreeLegend = (props ) => {
		const { activeItem } = this.state;

		 if (activeItem === "hospital") {
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span style={{ display: "inline-block" }} className="tag hospital">
								종합
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								종합병원
							</span>

							<span style={{ display: "inline-block" }} className="tag hospital2">
								요양
							</span>
							<span style={{ display: "inline-block" }} className="text">
								요양병원
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag hospital3">
								치과
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								치과병원
							</span>

							<span style={{ display: "inline-block" }} className="tag hospital4">
								정신
							</span>
							<span style={{ display: "inline-block" }} className="text">
								정신병원
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag hospital5">
								한방
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								한방병원
							</span>

							<span style={{ display: "inline-block" }} className="tag hospital6">
								의원
							</span>
							<span style={{ display: "inline-block" }} className="text">
								의원
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag hospital7">
								치과의원
							</span>
							<span style={{ display: "inline-block", marginRight: "26px" }} className="text">
								치과의원
							</span>

							<span style={{ display: "inline-block" }} className="tag hospital8">
								한의원
							</span>
							<span style={{ display: "inline-block" }} className="text">
								한의원
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag hospital9">
								부속
							</span>
							<span style={{ display: "inline-block" }} className="text">
								부속의원
							</span>
						</div>
					</div>
					
				</>
				
			);
			
		} else if (activeItem === "hospital_night") {
			return (
				<div className="legendWrap">
					<div
						className="legendToggle"
						onClick={(e) => {
							$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
							$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
						}}
					>
						<BsPlus className="legendVisible hide" size="18px" />
						<BsDash className="legendVisible" size="18px" />
					</div>

					<span className="legendTitle">
						<AiOutlineUnorderedList size="15px" />
						범례
					</span>
					<div className="legendContents">
						<span style={{ display: "inline-block" }} className="tag hospital">
							어린이
						</span>
						<span style={{ display: "inline-block", marginRight: "64px"}} className="text">
							공공심야어린이병원
						</span>

						<span style={{ display: "inline-block" }} className="tag hospital2">
							협력약국
						</span>
						<span style={{ display: "inline-block" }} className="text">
							협력약국
						</span>
						<br />

						<span style={{ display: "inline-block" }} className="tag hospital3">
							공공심야약국
						</span>
						<span style={{ display: "inline-block" }} className="text">
							공공심야약국
						</span>
					</div>
				</div>
			);
		}
		
	};

	// 검색
	search = async (evt) => {
		
		const { setLoading } = this.context; // ✅ context에서 setLoading 가져오기
    	setLoading(true); // 예제: 로딩 상태 변경
		$(".layerOpen").css("display","block");
		const { activeItem } = this.state;
		const { actions, sis } = this.props;
		const { sisLayer } = this.props.sis;
		let stdYmd = document.querySelector("select#selectLivingStdYmd");
		// stdYmd 값을 select에서 직접 가져오기
		if (stdYmd) {
			stdYmd = stdYmd.value ;
		} else {
			stdYmd = null;  // 요소가 없으면 기본값 null 설정
		}
		

		// 기준년도 값이 없으면 1초 대기 후 실행
		const waitForStdYmd = () => {
			return new Promise(resolve => {
			  if (!stdYmd || stdYmd.trim() === "") {
				//console.log("기준년도 값이 없습니다. 1초 대기 중...");
				// 1초 대기 후, resolve를 호출하여 대기 끝냄
				setTimeout(() => {
				  resolve(); // Promise를 해결하여 대기 종료
				}, 1000);
			  } else {
				//console.log("기준년도 값이 있습니다.");
				resolve(); // 바로 resolve하여 대기 없이 진행
			  }
			});
		};
		  if(activeItem === "hospital" || activeItem==="hospital_night"){
			// 비동기적으로 처리할 함수
			await waitForStdYmd(); // 기준년도 값이 없으면 1초 기다리기
		}
		 

		let title = "";
		let data = [];
		//let stdYmd = "";
		let guBun = "0";
		let tagId = "";
		if(activeItem===""){
			tagId = "dust";
		}
		
		if(activeItem === "hospital" || activeItem==="hospital_night"){
			stdYmd = $("select#selectLivingStdYmd").val() || $("select#selectLivingStdYmd option:first").val() || "0";
			//guBun = $("select#selectLivingGb").val();
			//guBun = $("#selectLivingGb").find("select").val();
			// ✅ 수정: State에 저장된 값을 바로 사용 (가장 정확함)
       		guBun = this.state.selectedGb;
		}

		if(guBun==null){
			guBun = "0";
		}
		if(activeItem === "weather"){

		}
		let params = {
			sggCode: $("select#selectLivingSgg").val(),
			emdCode: $("select#selectLivingEmd").val(),
			stdYmd: stdYmd,
			guBun: guBun,
		};
		//console.log(guBun);
		let color = "#ff0000";
		let url = "";
		let legend = "";
		let crsCode = "EPSG:4326";
		let opacity = 1;
		let id = `living_${activeItem}`;
		let layerName = "";
		let type = "point";

		if (activeItem === "hospital") {
			title = "의료시설 현황";
			crsCode = "EPSG:5186";
			color = "#ff5722";
			url = "/map/selectHospitalInfo";
			legend = this.createTreeLegend();
		}else if (activeItem === "hospital_night") {
			title = "야간 의료시설 현황";
			crsCode = "EPSG:5186";
			color = "#ff5722";
			url = "/map/selectHospitalNghitInfo";
			legend = this.createTreeLegend();
		}  
		if(activeItem === "tour"){
			$.ajax({
				url: "/map/getTourInformation",
				type: "post",
				data: {
					id : evt,
				},
				success: (res) => {
					if (res.length > 0) {
						const id = res[0].courseId;
						const lyr = sisLayer.getLayerById(`living_${evt}`);
	
						if (lyr) {
							actions.deleteResult({
								id: `living_${evt}`,
								refresh: true,
							});
						}
	
						const treeItem = this.createTreeItem({
							data: res,
							id: `living_${evt}`,
						});
						legend = this.createTreeLegend();
						actions.addResultItem({
							//data: legend,
							id: `living_${evt}`,
							title: res[0].courseNm,
							closeEvent: actions.deleteResult,
							checkboxEvent: actions.resultCheckboxHandler,
						});
						actions.addResultLayer({
							data: res,
							id: `living_${evt}`,
							type: "polyline",
							callback: () => {
								requestAnimationFrame(() => {
									setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
								  });
							  }
						});
	
						this.createOverlay(res, `living_${evt}`);
					}
				},
			});
		}else{
			if(type!=="geoserver"){

				$.ajax({
					url,
					type: "post",
					data: params,
					success: (res) => {
						data = res.items ? res.items : res;
		
						if (data.length === 0) {
							alert("검색결과가 없습니다.");
							setLoading(false);
							return;
						}
		
						if (res.wkt) {
							const feature = sis.sisLayer.createFeatureByWKT(res.wkt);
							feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
							const extent = feature.getGeometry().getExtent();
		
							sis.sisMap.view.fit(extent);
						}
		
						const lyr = sis.sisLayer.getLayerById(id);
		
						if (lyr) {
							actions.deleteResult({
								id,
								refresh: true,
							});
						}
		
						// 트리아이템 생성
						actions.addResultItem({
							data: legend,
							id,
							title,
							closeEvent: actions.deleteResult,
							checkboxEvent: actions.resultCheckboxHandler,
						});
		
						// 레이어 생성
						actions.addResultLayer({
							data,
							id,
							type: type,
							color,
							crsCode,
							opacity,
							callback: () => {
								requestAnimationFrame(() => {
									setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
								  });
							  }
						});
		
						// 오버레이 생성
						if (tagId != "dust") {
							this.createOverlay(data, id);
						} else {
							this.createDustOverlay(data, id);
						}
					},
				});
			}else{
				id = layerName;
				// 트리아이템 생성
				actions.addResultItem({
					data: legend,
					id,
					title,
					closeEvent: actions.deleteResult,
					checkboxEvent: actions.resultCheckboxHandler,
				});
				
				// 레이어 생성
				actions.addResultLayer({
					data,
					id,
					type: type,
					color,
					crsCode,
					opacity,
					layerName,
					callback: () => {
						requestAnimationFrame(() => {
							setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
						  });
					  },
					/*clickCallback: (featureProps) => {
						console.log("클릭된 Feature 데이터:", featureProps);
						//alert(`선택한 데이터: ${featureProps.manCnt ?? featureProps.womanCnt ?? featureProps.totalCnt ?? "정보 없음"}`);
						const currentLayerId = this.getLatestLayerId();
						this._overlayClickEvent(featureProps, featureProps.id,currentLayerId)
					}*/
				});
			}
		}
		
	};

	render() {
		const { activeItem } = this.state;
		const { lstSgg, defaultSggCd } = this.props.sis;
		let searchElement;

		 if ("hospital"===activeItem) {
					searchElement = (
						<>
							<div className="inputWrap">
								<span className="selectTitle">기준년도</span>
								<SisSelect
									id="selectLivingStdYmd"
									//ref={(ref) => (this.selectwelfareStdYmd = ref)}
									className="select"
									items={this.state.lstYmd}
									mapping={{
										key: "stdYmd",
										text: "stdName",
									}}
									
								/>
							</div>
							
							<div className="inputWrap">
								<span className="selectTitle">구명</span>
								<SisSelect
									id="selectLivingSgg"
									ref={(ref) => (this.selectwelfareSgg = ref)}
									className="select"
									items={lstSgg}
									/*defaultValue={defaultSggCd}*/
									mapping={{
										key: "sggCd",
										text: "sggNm",
									}}
									onChange={this.getEmd}
									onLoaded={this.getEmd}
								/>
							</div>
							<div className="inputWrap">
								<span className="selectTitle">동명</span>
								<SisSelect
									id="selectLivingEmd"
									ref={(ref) => (this.selectwelfareEmd = ref)}
									className="select"
									mapping={{
										key: "emdCd",
										text: "emdNm",
									}}
									items={this.state.lstEmd}
								/>
							</div>
							<div className="inputWrap">
								<span className="selectTitle">병원종류</span>
								<SisSelect
									id="selectLivingGb"
									//ref={(ref) => (this.selectwelfareGb = ref)}
									className="select"
									mapping={{
										key: "facilitiesGb",
										text: "facilitiesNm",
									}}
									items={this.state.lstGb}
									onChange={this.handleGbChange} // ✅ 추가: 값이 바뀔 때마다 state에 저장
								/>
							</div>
							
							<div className="btnWrap">
								<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
									검색
								</button>
							</div>
						</>
					);
				}else if ("hospital_night"===activeItem) {
					searchElement = (
						<>
							<div className="inputWrap">
								<span className="selectTitle">기준년도</span>
								<SisSelect
									id="selectLivingStdYmd"
									//ref={(ref) => (this.selectwelfareStdYmd = ref)}
									className="select"
									items={this.state.lstYmd}
									mapping={{
										key: "stdYmd",
										text: "stdName",
									}}
									
								/>
							</div>
							
							<div className="inputWrap">
								<span className="selectTitle">구명</span>
								<SisSelect
									id="selectLivingSgg"
									ref={(ref) => (this.selectwelfareSgg = ref)}
									className="select"
									items={lstSgg}
									/*defaultValue={defaultSggCd}*/
									mapping={{
										key: "sggCd",
										text: "sggNm",
									}}
									onChange={this.getEmd}
									onLoaded={this.getEmd}
								/>
							</div>
							<div className="inputWrap">
								<span className="selectTitle">동명</span>
								<SisSelect
									id="selectLivingEmd"
									ref={(ref) => (this.selectwelfareEmd = ref)}
									className="select"
									mapping={{
										key: "emdCd",
										text: "emdNm",
									}}
									items={this.state.lstEmd}
								/>
							</div>
							<div className="inputWrap">
								<span className="selectTitle">시설종류</span>
								<SisSelect
									id="selectLivingGb"
									//ref={(ref) => (this.selectwelfareGb = ref)}
									className="select"
									mapping={{
										key: "facilitiesGb",
										text: "facilitiesNm",
									}}
									items={this.state.lstGb}
									onChange={this.handleGbChange} // ✅ 추가: 값이 바뀔 때마다 state에 저장
								/>
							</div>
							
							<div className="btnWrap">
								<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
									검색
								</button>
							</div>
						</>
					);
				}

		return (
			<div id="livingWrap" className="contentsWrap">
				<div className="title">
					<span>{this.state.title}</span>
					<div className="close" onClick={this.closeSearchWrap}>
						<MdClose />
					</div>
				</div>
				<div className="source" style={{display:"none"}}>
					<span className="origin_tit">출처</span>
					<span className="origin_stxt">{this.state.source}</span>
				</div>
				<div className="itemsWrap">
					<div id="hospital" className="item" onClick={this.openSearchWrap}>
						<span>의료시설 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="hospital_night" className="item" onClick={this.openSearchWrap}>
						<span>야간 의료시설 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					
				</div>

				<div className="searchWrap">{searchElement}</div>
			</div>
		);
	}
}

function appendZeroValue(target) {
	if (target.toString().length === 1) {
		return "0" + target;
	} else {
		return target;
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		actions: bindActionCreators(sisMapActions, dispatch),
	})
)(Sanitary);
